import "./Chip.scss";

type ChipProps = {
  label?: string;
  isActive?: boolean;
  onClick?: () => void;
  children?: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;

export const Chip: React.FC<ChipProps> = ({ label, isActive, onClick, children, className }) => {
  const activeClass = isActive ? "active" : "";
  const clickableClass = onClick ? "chip--clickable" : "";

  return (
    <div
      className={`chip ${activeClass} ${clickableClass} ${className ?? ""}`}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
    >
      {label && <span>{label}</span>}
      {children && children}
    </div>
  );
};
